import styled from 'styled-components';
import React from 'react';

import { FlexRow, HeaderText, PageTile } from '@make-software/cspr-design';
import { Container } from '@/components';

const PageContentSection = styled.section(({ theme }) =>
  theme.withMedia({
    maxWidth: ['100%', '720px', '1200px'],
    width: '100%',
    margin: '0 auto',
    padding: '0 12px',
    paddingTop: '48px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  })
);

const HeaderRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  })
);

const TermsContent = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: `20px`,
    lineHeight: '1.6',
    '& h2': {
      margin: '8px 0 0',
      fontSize: '20px',
    },
    '& p': {
      margin: 0,
    },
  })
);

const TermsOfServiceScene = () => {
  return (
    <Container>
      <PageContentSection>
        <HeaderRow>
          <HeaderText size={2}>Terms of Service</HeaderText>
        </HeaderRow>

        <PageTile>
          <TermsContent>
            <p>
              <em>Last updated: January 27, 2026</em>
            </p>
            <p>
              Welcome to ChainMail. By using this proof of concept application, you agree to the
              following terms.
            </p>
            <h2>Proof of Concept Application</h2>
            <p>
              ChainMail is a proof of concept meant to explore decentralized, encrypted messaging
              technology on blockchain infrastructure. It is <strong>not a stable service yet</strong>
              , and you should not rely on it for secure or persistent communication.
            </p>
            <h2>No Guarantees</h2>
            <p>
              The application is provided <strong>as-is</strong>, with{' '}
              <strong>no guarantees</strong> of uptime, message delivery, data integrity, or future
              availability.
            </p>
            <h2>Use at Your Own Risk</h2>
            <p>
              By using ChainMail, you acknowledge and agree that you do so{' '}
              <strong>at your own risk</strong>. The developers, contributors, and maintainers shall
              not be held responsible for any issues, losses, or damages resulting from your use of
              this software.
            </p>
            <h2>Changes</h2>
            <p>These Terms may be updated at any time without notice.</p>
            <h2>Contact</h2>
            <p>
              For any questions regarding these Terms, please reach out via the contact method
              listed on the ChainMail homepage.
            </p>
          </TermsContent>
        </PageTile>
      </PageContentSection>
    </Container>
  );
};

export default TermsOfServiceScene;
